import { jsx as w, jsxs as F, Fragment as I } from "react/jsx-runtime";
import * as a from "react";
import { cn as z } from "../../../lib/utils.js";
const C = a.forwardRef(({ active: o = !1, origin: r, particleCount: h = 120, colors: s = ["#f43f5e", "#06b6d4", "#8b5cf6", "#f59e0b", "#10b981"], duration: u = 3e3, spread: n = 360, startVelocity: g = 30, className: f }, x) => {
  const d = a.useRef(null), m = a.useRef(0), M = a.useRef([]);
  return a.useEffect(() => {
    if (!o) {
      cancelAnimationFrame(m.current);
      const l = d.current;
      if (l) {
        const c = l.getContext("2d");
        c == null || c.clearRect(0, 0, l.width, l.height);
      }
      return;
    }
    const i = d.current;
    if (!i)
      return;
    const e = i.getContext("2d");
    if (!e)
      return;
    i.width = window.innerWidth, i.height = window.innerHeight;
    const v = (r == null ? void 0 : r.x) ?? i.width / 2, S = (r == null ? void 0 : r.y) ?? i.height * 0.35, R = ["circle", "rect", "strip"];
    M.current = Array.from({ length: h }, (l, c) => {
      const y = Math.random() * n * Math.PI / 180 - n * Math.PI / 360, t = g * (0.5 + Math.random() * 0.8);
      return {
        id: c,
        x: v + (Math.random() - 0.5) * 10,
        y: S + (Math.random() - 0.5) * 10,
        color: s[Math.floor(Math.random() * s.length)] ?? "#000",
        size: Math.random() * 6 + 3,
        velocityX: Math.sin(y) * t,
        velocityY: -Math.abs(Math.cos(y) * t) - Math.random() * 15,
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 15,
        gravity: 0.25 + Math.random() * 0.15,
        drag: 0.97 + Math.random() * 0.02,
        life: 1,
        shape: R[Math.floor(Math.random() * R.length)]
      };
    });
    const A = performance.now(), b = (l) => {
      const c = l - A, y = Math.min(c / u, 1);
      e.clearRect(0, 0, i.width, i.height), M.current = M.current.filter((t) => (t.velocityX *= t.drag, t.velocityY *= t.drag, t.velocityY += t.gravity, t.x += t.velocityX, t.y += t.velocityY, t.rotation += t.rotationSpeed, t.life = Math.max(0, 1 - y * 1.2 + Math.random() * 0.1), t.y > i.height + 20 || t.life <= 0 ? !1 : (e.save(), e.translate(t.x, t.y), e.rotate(t.rotation * Math.PI / 180), e.globalAlpha = Math.min(t.life, 1), e.fillStyle = t.color, t.shape === "circle" ? (e.beginPath(), e.arc(0, 0, t.size / 2, 0, Math.PI * 2), e.fill()) : t.shape === "rect" ? e.fillRect(-t.size / 2, -t.size / 2, t.size, t.size * 0.6) : e.fillRect(-t.size / 2, -1, t.size, 2.5), e.restore(), !0))), y < 1 && M.current.length > 0 ? m.current = requestAnimationFrame(b) : e.clearRect(0, 0, i.width, i.height);
    };
    return m.current = requestAnimationFrame(b), () => {
      cancelAnimationFrame(m.current);
    };
  }, [o, r, h, s, u, n, g]), o ? w("div", { ref: x, className: z("fixed inset-0 pointer-events-none z-[100]", f), children: w("canvas", { ref: d, className: "w-full h-full" }) }) : null;
});
C.displayName = "Confetti";
const N = a.forwardRef(({ children: o, confettiConfig: r = {}, triggerOnClick: h = !0, onClick: s, className: u, ...n }, g) => {
  const f = a.useRef(null), [x, d] = a.useState(!1), [m, M] = a.useState();
  return a.useImperativeHandle(g, () => f.current), F(I, { children: [w("button", { ref: f, onClick: (e) => {
    if (h && f.current) {
      const v = f.current.getBoundingClientRect();
      M({
        x: v.left + v.width / 2,
        y: v.top + v.height / 2
      }), d(!0), setTimeout(() => d(!1), r.duration || 3e3);
    }
    s == null || s(e);
  }, className: z("relative inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3", "bg-lpr-teal text-white font-semibold transition-all duration-300", "hover:bg-lpr-teal/90 hover:shadow-luxury hover:-translate-y-1", "focus:outline-none focus:ring-2 focus:ring-lpr-teal/50 focus:ring-offset-2", "active:scale-95", u), ...n, children: o }), w(C, { active: x, origin: m, ...r })] });
});
N.displayName = "ConfettiButton";
const X = () => {
  const [o, r] = a.useState(!1), [h, s] = a.useState(), u = a.useCallback((n) => {
    n != null && n.origin && s(n.origin), r(!0), setTimeout(() => r(!1), (n == null ? void 0 : n.duration) || 3e3);
  }, []);
  return { active: o, origin: h, trigger: u };
};
export {
  C as Confetti,
  N as ConfettiButton,
  X as useConfetti
};
//# sourceMappingURL=Confetti.js.map
